import { render, staticRenderFns } from "./DigitalMachine.vue?vue&type=template&id=bfc07bca&scoped=true"
import script from "./DigitalMachine.vue?vue&type=script&lang=js"
export * from "./DigitalMachine.vue?vue&type=script&lang=js"
import style0 from "./DigitalMachine.vue?vue&type=style&index=0&id=bfc07bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc07bca",
  null
  
)

export default component.exports